import type { DocumentType } from 'src/apis/document-exchange/types';
import { labelsToOptions } from 'src/utils/labels-to-options';
import { labelsToValues } from 'src/utils/labels-to-values';

type FromShipperDocumentsSortBy = 'changedAt' | 'fileName' | 'category';

const fromShipperDocumentsSortByLabels: Record<
  FromShipperDocumentsSortBy,
  string
> = {
  changedAt: 'Date',
  fileName: 'Name',
  category: 'Type',
};

export const fromShipperDocumentsSortByValue = labelsToValues(
  fromShipperDocumentsSortByLabels
);

type ShipperDocumentsSortBy = 'CHANGED_AT';

const shipperDocumentsSortByLabels: Record<ShipperDocumentsSortBy, string> = {
  CHANGED_AT: 'Date',
};

export const shipperDocumentsSortByValues = labelsToValues(
  shipperDocumentsSortByLabels
);

export const documentTypeLabels: Record<DocumentType, string> = {
  BUSINESS_COMMUNICATION: 'Business Communication',
};

export const documentTypeOptions = labelsToOptions(documentTypeLabels);

export const documentTypeValues = labelsToValues(documentTypeLabels);
